import { actions, defaults, selectors } from '@sloyd/store-base';
import { bridge } from '@sloyd/viewer';
import { delay, fork, put, select, takeEvery } from 'saga-ts';
import { invokeEvent, l, patchJson } from 'shared-base';
import { saveEnvironmentOnModel } from './helpers/environment';
import { unityGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.holodeck',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['HOLODECK'],
  },
};

type Verb =
  | 'bootstrap' //
  | 'reset'
  | 'patch';

type Action = {
  type: 'HOLODECK';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  bootstrap: bootstrap,
  reset: reset,
  patch: patch,
};

export function* bootstrap(_action: Action) {
  try {
    const holodeckState = yield* select(selectors.base.$holodeck);

    console.time('unityGuard');
    yield unityGuard();
    console.timeEnd('unityGuard');

    bridge.patchEnvironment('main', holodeckState);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* reset(_action: Action) {
  try {
    yield put(actions.holodeckState.patch(defaults.holodeckState));
    yield fork(bootstrap, _action);
    patchJson('holodeckState', defaults.holodeckState);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* patch(action: Action) {
  try {
    const { payload } = action;
    const { paramType, popId, value } = payload;

    const map: any = {
      grid: {
        color: 'gridLinesColor',
        intensity: 'gridLinesOpacity',
      },
      ambience: {
        color: 'lightColor',
        intensity: 'lightIntensity',
      },
      background: {
        color: 'backgroundColor',
        intensity: 'backgroundIntensity',
      },
      backdrop: {
        enabled: 'backdropEnabled',
        color: 'backdropId',
        intensity: 'backdropGrainIntensity',
      },
    };

    const key = map[popId][paramType];

    if (!key) return;

    const change = { [key]: value };

    yield put(actions.holodeckState.patch(change));
    yield fork(saveEnvironmentOnModel);
    if (popId === 'backdropId') return;
    patchJson('holodeckState', change);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* holodeck(action: any) {
  const { verb, id } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.holodeck ${verb}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('HOLODECK', holodeck);
}
